import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '@mui/material/LinearProgress'
import {
  POLICY_STATUS_TYPES,
  POLICY_UPLOAD_METHOD,
} from 'src/utils/constants/common'
import { Button, Tooltip, Zoom } from '@mui/material'
import reportInvalid from 'src/assets/PolicyTile_Images/Group1296.svg'
import uploadImg from 'src/assets/PolicyTile_Images/Group7.svg'
import { COLORS } from 'src/utils/Themes/colors'
import { CLICK_TO_DOWNLOAD } from 'src/utils/constants/Individual'

const InvalidDocumentBar = ({
  status,
  documentDownload,
  policyDetails,
  invokeSxp,
}) => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.mainContainer}>
        <Tooltip
          TransitionComponent={Zoom}
          placement='top'
          title={CLICK_TO_DOWNLOAD}
          arrow
        >
          <img
            src={reportInvalid}
            className={classes.reportIcon}
            onClick={documentDownload}
            alt={'Report'}
          />
        </Tooltip>

        <LinearProgress
          variant='indeterminate'
          className={classes.progressContainer}
        />
        {status === POLICY_STATUS_TYPES?.documentRequired ? (
          <span className={classes.statusText}>Document Upload Pending.</span>
        ) : (
          <span className={classes.statusText}>
            Invalid document{' ( '}
            <span className={classes.agentCommentsContainer}>
              {policyDetails?.agentComments}
            </span>
            {' ) '}
          </span>
        )}
        <div>
          {policyDetails?.policyUploadedMethod ===
          POLICY_UPLOAD_METHOD?.manual ? (
            <Button
              className={classes.uploadButton}
              onClick={(event) => {
                // !policyDetails.agentComments || policyDetails.agentComments === ''
                //   ? invokeSxp(event, policyDetails, 'uploadDocumentTile')
                //   : might be future use
                invokeSxp(event, policyDetails, 'policyUploadManual')
              }}
            >
              Upload Policy
              <img
                src={uploadImg}
                className={classes.uploadImage}
                alt='Upload'
              />
            </Button>
          ) : (
            <Button
              className={classes.uploadButton}
              onClick={(event) => {
                invokeSxp(event, policyDetails, 'digiUploadDocument')
              }}
            >
              Upload Policy
              <img
                src={uploadImg}
                className={classes.uploadImage}
                alt='Upload'
              />
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default InvalidDocumentBar

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  agentCommentsContainer: {
    fontWeight: 'bold',
  },
  digitalizingTextContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  statusText: {
    fontSize: '12px',
    color: '#E66E6E',
  },
  progressContainer: {
    width: '100%',
    backgroundColor: 'rgb(30, 119, 104) !important',
    borderRadius: '50px',
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'rgb(30, 119, 104) !important',
    },
  },
  reportIcon: {
    width: '25px',
    height: '25px',
    marginBottom: '-25px',
    zIndex: '20',
  },
  uploadButton: {
    textTransform: 'unset !important',
    fontWeight: '600 !important',
    background: `${COLORS.WHITE} !important`,
    color: `${COLORS.LINK_COLOR_DARK} !important`,
    margin: '0 !important',
    height: '24px',
    borderRadius: '6px !important',
    border: '1px solid #02A9F4 !important',
    fontSize: '9px !important',
    '&:hover': {
      backgroundColor: `${COLORS.WHITE} !important`,
    },
  },
  uploadImage: {
    width: '13px',
    paddingLeft: '5px',
    paddingBottom: '4px',
  },
})
